// =============================================
// Royal Honey México — Theme Scripts v4
// =============================================

document.addEventListener('DOMContentLoaded', function () {

  // ---- 1. AGE GATE ----
  var gate = document.getElementById('rhmx-age-gate');
  if (gate) {
    if (localStorage.getItem('rhmx-age')) {
      gate.style.display = 'none';
    } else {
      gate.style.display = 'flex';
      var enterBtn = document.getElementById('rhmx-age-enter');
      if (enterBtn) {
        enterBtn.addEventListener('click', function () {
          localStorage.setItem('rhmx-age', '1');
          gate.style.transition = 'opacity 350ms';
          gate.style.opacity = '0';
          setTimeout(function () { gate.style.display = 'none'; }, 380);
        });
      }
    }
  }

  // ---- 2. CART ICON ----
  // Handled entirely by CSS (rhmx-custom.css ::before pseudo-element).
  // No JS needed — CSS data URI SVG is injected directly, can't be broken.

  // ---- 3. STRIP ANNOUNCEMENT BAR PREFIX ("AE:", "Ar:", "Añ:", etc.) ----
  // Uses MutationObserver so it catches EVERY re-render, forever
  var PREFIX_RE = /^[A-Za-zÀ-ɏ]{1,5}:\s*/;

  function stripPrefix(el) {
    el.childNodes.forEach(function (node) {
      if (node.nodeType === 3) {
        var t = node.textContent;
        if (PREFIX_RE.test(t.trim())) {
          node.textContent = t.replace(PREFIX_RE, '');
        }
      }
    });
    // Also check first child element (some themes wrap label in a span)
    if (el.firstElementChild && PREFIX_RE.test(el.firstElementChild.textContent.trim())) {
      el.firstElementChild.textContent = el.firstElementChild.textContent.replace(PREFIX_RE, '');
    }
  }

  function cleanAllAnnouncements() {
    var targets = document.querySelectorAll(
      '.announcement-bar__message, .announcement-bar__link p, ' +
      '.announcement-bar__segment p, [class*="announcement"] p, ' +
      '[class*="announcement"] span, .rhmx-announce-item'
    );
    targets.forEach(stripPrefix);
  }

  // Run immediately
  cleanAllAnnouncements();

  // Watch the entire announcement bar for ANY change and re-strip
  var announceBars = document.querySelectorAll(
    '.announcement-bar, [class*="announcement-bar"], .rhmx-announce'
  );
  if (announceBars.length && window.MutationObserver) {
    var annObs = new MutationObserver(cleanAllAnnouncements);
    announceBars.forEach(function (bar) {
      annObs.observe(bar, { childList: true, subtree: true, characterData: true });
    });
  }

  // ---- 4. FIX NAV 404s ----
  document.querySelectorAll('.header__icon--account, a[href="/account"]').forEach(function (el) {
    el.style.display = 'none';
  });
  document.querySelectorAll('a[href*="/pages/contact"]').forEach(function (a) {
    a.href = 'https://wa.me/526861155413';
    a.target = '_blank';
    a.rel = 'noopener';
  });

  // ---- 5. SMOOTH SCROLL — hero CTA → #collection ----
  document.querySelectorAll('.rhmx-scroll-to-collection, a[href="#collection"]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var target = document.getElementById('collection');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ---- 6. HERO PARALLAX ----
  if (document.querySelector('.rhmx-hero')) {
    var heroBg        = document.querySelector('.rhmx-hero-bg');
    var heroHoneycomb = document.querySelector('.rhmx-hero-honeycomb');
    var heroText      = document.querySelector('.rhmx-hero-text');
    var heroScrollHint = document.querySelector('.rhmx-hero-scroll-hint');
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var op = Math.max(0, 1 - y / 700);
      if (heroBg) heroBg.style.opacity = op;
      if (heroHoneycomb) {
        heroHoneycomb.style.transform = 'translateY(' + (-y * 0.18) + 'px)';
        heroHoneycomb.style.opacity = (op * 0.35).toString();
      }
      if (heroText) {
        heroText.style.transform = 'translateY(' + (y * 0.175) + 'px)';
        heroText.style.opacity = op.toString();
      }
      if (heroScrollHint) heroScrollHint.style.opacity = (op * 0.7).toString();
    }, { passive: true });
  }

  // ---- 7. FADE-IN ON SCROLL ----
  var fadeEls = document.querySelectorAll('.rhmx-fade-in');
  if (fadeEls.length && window.IntersectionObserver) {
    var fadeObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          setTimeout(function () { e.target.classList.add('rhmx-in'); },
            parseInt(e.target.dataset.delay || '0', 10));
          fadeObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    fadeEls.forEach(function (el) { fadeObs.observe(el); });
  } else {
    fadeEls.forEach(function (el) { el.classList.add('rhmx-in'); });
  }

  // ============================================================
  // ---- 8. PDP — stop here if not a product page ----
  // ============================================================
  // Support both v1 and v2 product templates
  var pdpWrap = document.querySelector('.rhmx-pdp2-wrap') || document.querySelector('.rhmx-pdp-wrap');
  if (!pdpWrap) return;

  // -- Price helpers --
  // Read unit price directly from Liquid data attribute (cents)
  var bundleGrid    = document.getElementById('rhmx-bundle-grid');
  var unitPriceCents = bundleGrid ? parseInt(bundleGrid.dataset.unitPrice, 10) : 0;
  var currentQty    = 1;

  var variantIdInput = document.getElementById('rhmx-variant-id');
  var priceEl        = document.getElementById('rhmx-price');
  var comparePriceEl = document.getElementById('rhmx-compare-price');
  var atcBtn         = document.getElementById('rhmx-atc-btn');
  var qtyInput       = document.getElementById('rhmx-qty');

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }

  function refreshUI() {
    var total = unitPriceCents * currentQty;
    if (priceEl) priceEl.textContent = money(total);
    // Update qty input (sent to Shopify checkout)
    if (qtyInput) qtyInput.value = currentQty;
  }

  // ---- Bundle selector (1 / 3 / 6) ----
  // Use event delegation on the grid container — more reliable than per-button listeners
  if (bundleGrid) {
    bundleGrid.addEventListener('click', function (e) {
      var btn = e.target.closest('.rhmx-bundle-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      // Mark active
      bundleGrid.querySelectorAll('.rhmx-bundle-btn').forEach(function (b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');

      // Update qty
      currentQty = parseInt(btn.dataset.qty, 10) || 1;
      refreshUI();
    });
  }

  // ---- Variant pills ----
  var variantsContainer = document.getElementById('rhmx-variants');
  if (variantsContainer) {
    variantsContainer.addEventListener('click', function (e) {
      var btn = e.target.closest('.rhmx-pdp-variant');
      if (!btn || btn.disabled) return;

      variantsContainer.querySelectorAll('.rhmx-pdp-variant').forEach(function (b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');

      unitPriceCents = parseInt(btn.dataset.price, 10) || 0;
      var cmp        = parseInt(btn.dataset.compare, 10) || 0;
      var avail      = btn.dataset.available === 'true';

      if (variantIdInput) variantIdInput.value = btn.dataset.variantId;

      // Update bundle price labels
      [1, 3, 6].forEach(function (q) {
        var el = document.getElementById('rhmx-bundle-p' + q);
        if (el) el.textContent = money(unitPriceCents * q) + ' MXN';
      });

      // Update compare price
      if (comparePriceEl) {
        if (cmp && cmp > unitPriceCents) {
          comparePriceEl.textContent = money(cmp * currentQty);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      if (atcBtn) {
        atcBtn.disabled = !avail;
        atcBtn.textContent = avail ? 'Agregar al Carrito →' : 'Agotado';
      }

      refreshUI();
    });
  }

  // ---- Quantity +/- ----
  var qtyMinus = document.getElementById('rhmx-qty-minus');
  var qtyPlus  = document.getElementById('rhmx-qty-plus');
  if (qtyMinus) {
    qtyMinus.addEventListener('click', function () {
      currentQty = Math.max(1, currentQty - 1);
      // Clear bundle active state (user overriding manually)
      if (bundleGrid) bundleGrid.querySelectorAll('.rhmx-bundle-btn').forEach(function (b) { b.classList.remove('active'); });
      refreshUI();
    });
  }
  if (qtyPlus) {
    qtyPlus.addEventListener('click', function () {
      currentQty += 1;
      if (bundleGrid) bundleGrid.querySelectorAll('.rhmx-bundle-btn').forEach(function (b) { b.classList.remove('active'); });
      refreshUI();
    });
  }

  // ---- Gallery thumbnails ----
  var mainImg = document.querySelector('#rhmx-main-img img');
  var thumbs  = document.querySelectorAll('.rhmx-pdp-thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg && thumb.dataset.src) {
        mainImg.style.opacity = '0.4';
        mainImg.src = thumb.dataset.src;
        mainImg.onload = function () {
          mainImg.style.transition = 'opacity 200ms';
          mainImg.style.opacity = '1';
        };
      }
    });
  });

}); // end DOMContentLoaded